import React, { Component } from "react";
import client from "@culturehq/client";
import { Button, Loader, Pagination, Table, Warning } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";

import { createEntity, updateEntity, deleteEntity } from "./mutations";
import InterestsExport from "./interests/InterestsExport";
import InterestModal from "./interests/InterestModal";
import InterestRow from "./interests/InterestRow";

const createInterest = createEntity("interests");
const updateInterest = updateEntity("interests");
const deleteInterest = deleteEntity("interests");

class InterestsContext extends Component {
  state = { loading: true, interests: [] };

  componentDidMount() {
    const { match } = this.props;

    this.fetchInterests(match.params.page || 1);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;

    if (match.params.page !== prevProps.match.params.page) {
      this.fetchInterests(match.params.page || 1);
    }
  }

  handlePageClick = page => {
    const { history } = this.props;

    history.push(`/admin/interests/${page}`);
  };

  handleCreate = interest => {
    this.setState(createInterest(interest));
  };

  handleUpdate = interest => {
    this.setState(updateInterest(interest));
  };

  handleDelete = interest => {
    this.setState(deleteInterest(interest));
  };

  async fetchInterests(page) {
    this.setState({ loading: true });

    const { interests, pagination } = await client.listInterests({ page });

    this.setState({ loading: false, interests, pagination });
  }

  render() {
    const { profile: { culturehqAdmin } } = this.props;
    const { interests, loading, pagination } = this.state;

    return (
      <div className="padding-left-15px padding-right-15px">
        <PageHeader title={t("Manage Interests")}>
          <Trans>
            The below is a list of interests that users and admins have created.
            They will appear in a preset list for users to choose from when
            editing their profile pages or tagging events. Interests on profile
            pages will allow users to discover others with similar hobbies and
            passions.
          </Trans>
        </PageHeader>

        {culturehqAdmin && <InterestsExport />}

        <InterestModal onCreate={this.handleCreate}>
          {onTrigger => (
            <Button icon="plus" primary onClick={onTrigger}>
              <Trans>Add an Interest</Trans>
            </Button>
          )}
        </InterestModal>

        <Loader loading={loading}>
          <Table>
            <thead>
              <tr>
                <th>Name</th>
                <th className="actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {interests.map(interest => (
                <InterestRow
                  key={interest.id}
                  interest={interest}
                  onUpdate={this.handleUpdate}
                  onDelete={this.handleDelete}
                />
              ))}
            </tbody>
          </Table>

          {interests.length < 1 && (
            <Warning>
              <strong>Uh oh!</strong> No results to show.
            </Warning>
          )}

          <Pagination {...pagination} onClick={this.handlePageClick} />
        </Loader>
      </div>
    );
  }
}

const Interests = props => {
  const { profile } = useProfile();

  return <InterestsContext {...props} profile={profile} />;
};

export default Interests;
